import { reduxForm } from 'redux-form';
import DatesSearchForm from '../components/DatesSearchForm';
import type { DatesSearchFormProps, DatesSearchProps } from '../models';
import { CHANGE_TRIP } from '../../../constants/formNamesConstants';

const withReduxForm = reduxForm<DatesSearchFormProps, DatesSearchProps>({
  form: CHANGE_TRIP,
  destroyOnUnmount: false,
  enableReinitialize: true,
});

export default withReduxForm(DatesSearchForm);
